const map = new Map();

export const dbSet = (key, value) => {
  map.set(key, value);
}

export const dbGet = (key) => {
  return map.get(key);
}

export const dbRemove = (key) => {
  map.delete(key);
}